// Tema claro/escuro. A fonte de verdade é o store de preferências (persistido). Aqui:
//  - useApplyTheme(): aplica/retira a classe `dark` no <html> conforme o tema; retorna o tema atual.
//  - ThemeToggle: botão de alternância (sol/lua).
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePreferences } from "./preferences-store.js";

export function useApplyTheme() {
  const theme = usePreferences((s) => s.theme);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);
  return theme;
}

export function ThemeToggle() {
  const { t } = useTranslation();
  const theme = usePreferences((s) => s.theme);
  const toggleTheme = usePreferences((s) => s.toggleTheme);
  const isDark = theme === "dark";
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={isDark ? t("common.themes.light") : t("common.themes.dark")}
      title={isDark ? t("common.themes.light") : t("common.themes.dark")}
    >
      {isDark ? <Sun /> : <Moon />}
    </Button>
  );
}
